<template lang="pug">
  .div
    h2.title Deliveries Integration

    .form-section
      .input-container
        label.label Choose File
        input.input(ref="input" type="file" accept=".csv" autocomplete="ño" required)
        div(@click="readFile") Read File
        div {{ message }}
</template>

<script>
import gql from '@my/graphql'
import gqlDelivery from '@/graphql/delivery'

export default {
  name: 'DeliveriesIntegration',

  data () {
    return {
      message: '',
      csv: '',
      titleNames: { orderNumber: 0, order: 1, name: 2, address: 3, location: 4, department: 5, phone: 6, methodPay: 7, conveyor: 8, guide: 9, collect: 10 }
    }
  },

  methods: {
    readFile () {
      if (!this.$refs.input.files.length) return
      const file = this.$refs.input.files[0]
      const reader = new FileReader()
      this.message = 'Cargando...'
      reader.onload = () => {
        this.csv = reader.result
        this.message = 'Cargado'
        this.csvToObject()
      }
      reader.readAsText(file)
    },

    async csvToObject () {
      const _ = this.titleNames
      const lines = this.csv.split('\r\n')

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i]
        const v = line.split(';')
        const delivery = { order: v[_.order], status: 'delivered', charge: parseInt(v[_.collect]), nameRecipient: v[_.name], locationRecipient: v[_.location], departmentRecipient: v[_.department], addressRecipient: v[_.address], phonesRecipient: [v[_.phone]], conveyor: v[_.conveyor], tracking: v[_.guide].toString() || '', version: 0 }

        if (i) await this.newDelivery(delivery)
      }
    },

    async newDelivery (delivery) {
      const mutation = gqlDelivery.INTEGRATION

      const variables = { delivery }

      const response = await gql.mutate(mutation, variables, false)

      console.log(response)

      if (response) {
        console.log(`The product '${delivery.order}' ha sido creado`)
      } else {
        console.log(`%c------------- The order '${delivery.order}' ha tenido un error al crearse`, 'background: red; color: white')
        console.log(response.error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/integrations/Deliveries.vue